import { useRef } from 'react'
import { useRequest } from 'ahooks'

import { Table } from '@sar/component'
import { Input, Space } from 'antd'

async function fetchData (params, store) {
  const result = await store.externals.api.get(`/dealer`, {
    params: Object.assign(params, {
      page: params.current,
      size: params.pageSize,
    })
  })

  return {
    success: true,
    data: result.data,
    total: result.totals,
  }
}

export default function ({ store, navigator }) {
  const columns = [
    {
      title: '订单编号',
      dataIndex: 'number',
    },
    {
      title: '客户姓名',
      dataIndex: 'customerName',
    },
    {
      title: '联系电话',
      dataIndex: 'customerPhone',
      render: _ => _.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2'),
    },
    {
      title: '地址',
      dataIndex: 'customerAddress',
    },
    {
      title: '信息来源',
      dataIndex: 'customerSource',
    },
    {
      title: '总金额',
      dataIndex: 'totalAmount',
    },
    {
      title: '已付款',
      dataIndex: 'paidAmount',
    },
    {
      title: '待付款',
      dataIndex: 'balance',
      render: (_, data) => R.defaultTo(0, data.totalAmount) - R.defaultTo(0, data.paidAmount),
    },
    {
      title: '跟踪员',
      dataIndex: 'saleName',
    },
    {
      title: '生产类型',
      dataIndex: 'type',
      valueType: 'select',
      valueEnum: store.config.getConstantEnums(`OrderType`),
    },
    {
      title: '订单状态',
      dataIndex: 'status',
      valueType: 'select',
      valueEnum: store.config.getConstantEnums(`OrderStatus`),
    },
  ]

  const rowActions = [
    {
      name: '详情',
      visible: () => store.identity.hasPermission('/order/dealer:detail'),
      onClick: (data, handles) => navigator.to(`/order/list/detail/${data.id}`, `查看订单（${data.customerName}）`),
    },
  ]

  const cols = React.useMemo(() => {
    let showSearch = [
        'customerPhone'
    ]

    return columns.map(column => {
      if (showSearch.includes(column.dataIndex)) {
        return Object.assign(column)
      }

      else {
        return Object.assign(column, { hideInSearch: true })
      }
    })
  }, [])

  return <div className='p-4'>
    <Table
      scroll={{ }}
      title='订单列表'
      columns={cols}
      rowActions={rowActions}
      request={params => fetchData(params, store)}
      search={{ labelWidth: 'auto', span: store.config.responsive }}
    />
  </div>
}
